module.exports = __webpack_public_path__ + "img/cd.ad03efd0.svg";